function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError, loginObj } from '@/services/base';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['master_data']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8090')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = 'Bearer ' + window.userInfo.accessToken;
  return config;
};

//appApisGTW.before(beforeMiddleware)
setupInterceptors(appApisGTW);
var CONTROLLER_NAME = '/master_data';
var DOMAIN_ROLES = '/roles';
export default {
  userRolesQuery: function userRolesQuery(data) {
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/userRolesQuery/"), body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(userRolesQuery) Search user roles';
      var response = validateError(err, message, function () {
        appApisGTW.userRolesQuery(data);
      });
      // const response = validateError(err, message)
      return response;
    });
  },
  getRoles: function getRoles() {
    var _this = this;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/get_all"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      var message = '(Roles) Search user roles';
      var response = validateError(err, message, function () {
        _this.getRoles(data);
      });
      // const response = validateError(err, message)
      return response;
    });
  },
  userRolesAddUpdate: function userRolesAddUpdate(data) {
    var _this2 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/crear_editar"), body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(userRolesAddUpdate) Add or Update new role';
      var response = validateError(err, message, function () {
        _this2.userRolesAddUpdate(data);
      });
      // const response = validateError(err, message)
      return response;
    });
  },
  userRolesDelete: function userRolesDelete(data) {
    var _this3 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/delete"), body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(userRolesDelete) Delete role';
      var response = validateError(err, message, function () {
        _this3.userRolesDelete(data);
      });
      // const response = validateError(err, message)
      return response;
    });
  },
  roleDelete: function roleDelete() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/delete"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  },
  userRolesLogQuery: function userRolesLogQuery(data) {
    var _this4 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/userRolesLogQuery"), body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(userRolesLogQuery) Search user roles';
      var response = validateError(err, message, function () {
        _this4.userRolesLogQuery(data);
      });
      // const response = validateError(err, message)
      return response;
    });
  },
  roleLogQuery: function roleLogQuery() {
    var _this5 = this;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/userRolesLogQuery"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      var message = '(Roles) Search user roles';
      var response = validateError(err, message, function () {
        _this5.roleLogQuery(data);
      });
      // const response = validateError(err, message)
      return response;
    });
  },
  userRolesValidateExist: function userRolesValidateExist(data) {
    var _this6 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/userRolesValidateExist"), body).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(userRolesValidateExist) Search user roles';
      var response = validateError(err, message, function () {
        _this6.userRolesValidateExist(data);
      });
      // const response = validateError(err, message)
      return response;
    });
  },
  roleValidateExist: function roleValidateExist() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/userRolesValidateExist"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  },
  create_user: function create_user(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/create_user"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  },
  edit_user: function edit_user(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/edit_user"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (error) {
      console.error(error);
    });
  },
  DownloadUsers: function DownloadUsers() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/download_users"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  deleteUser: function deleteUser(email, domain) {
    var login = loginObj();
    var body = {
      login: login
    };
    body["email"] = email;
    body["domain"] = domain;
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/delete_user"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  massiveUser: function massiveUser(data, domain) {
    var login = loginObj();
    var body = {
      login: login
    };
    body["data"] = data;
    body["domain"] = domain;
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES, "/massive_user"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  }
};